function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.671 2.58a2.386 2.386 0 012.153 2.357v10.691a2.388 2.388 0 01-2.369 2.369H4.521a2.388 2.388 0 01-2.369-2.369v-.211a2.386 2.386 0 01-2.151-2.359V2.365a2.388 2.388 0 012.37-2.369H10.3a2.383 2.383 0 012.271 1.7h-1.316a1.2 1.2 0 00-.975-.505H2.393c-.658 0-1.2.542-1.2 1.2V13.04a1.21 1.21 0 00.957 1.175V7.04a1.846 1.846 0 01.544-1.312l.65-.649 1.32-1.317.651-.65a1.852 1.852 0 011.184-.537c.042-.005.083-.005.125-.005h6.047v.01zm.957 13.03l-.002-10.653a1.204 1.204 0 00-1.199-1.199H6.543v1.314c0 .98-.806 1.786-1.786 1.786H3.342v8.752c0 .658.542 1.2 1.2 1.2h7.886c.658 0 1.2-.542 1.2-1.2zm-1.244-4.821c0 .39-.317.707-.707.707H5.298a.708.708 0 010-1.415h6.379c.39 0 .707.317.707.708zm0-3.073a.703.703 0 01-.702.702H7.983a.703.703 0 010-1.405h3.699c.387 0 .702.315.702.703zm0 6.141c0 .39-.317.707-.707.707H5.298a.708.708 0 010-1.415h6.379c.39 0 .707.317.707.708z",
  fill: "#0d5a91"
});

var SvgBespokenCopyIcon = function SvgBespokenCopyIcon(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 18,
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgBespokenCopyIcon;